import Tag from "../atoms/Tag";
import { NewsItem } from "../molecules/NewsCard";
import { Link, useLocation } from "react-router-dom";

type Props = {
  item: NewsItem;
};

const NewsHighlight = ({ item }: Props) => {
  const location = useLocation();
  const lang = location.pathname.startsWith("/id") ? "id" : "en";

  const truncateHtmlText = (html: string, maxLength: number) => {
  const temp = document.createElement("div");
  temp.innerHTML = html;
  const text = temp.textContent || temp.innerText || "";

  return text.length > maxLength
    ? text.slice(0, maxLength) + "..."
    : text;
};

  return (
    <Link to={`/${lang}/blog/news/${item.slug}`}>
      <div className="relative w-full rounded-xl overflow-hidden shadow-xl mb-2 md:mb-10 cursor-pointer">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-auto object-cover aspect-[5/3]"
        />

        <div
          className="
            absolute inset-0 bg-gradient-to-r 
            from-black/80 via-black/60 to-transparent
            md:from-black/70 md:via-black/50
          "
        ></div>

        <div
          className="
            absolute text-white 
            md:left-10 md:top-1/2 md:-translate-y-1/2 
            left-5 right-5 bottom-6 content-center
          "
        >
          <Tag label={item.category} />

          <h2 className="mt-3 font-bold text-2xl md:text-3xl leading-snug">
            {item.title}
          </h2>

           {item.tags?.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-1">
              {item.tags.map((tag, index) => (
                <span
                  key={index}
                  className="text-xs bg-white/30 px-2 py-0.5 rounded-full"
                >
                  #{tag}
                </span>
              ))}
            </div>
          )}

          <p
  className="hidden md:block text-gray-200 mt-3 max-w-[480px]"
  dangerouslySetInnerHTML={{
    __html: truncateHtmlText(item.contentHtml, 50),
  }}
/>

          <p className="text-sm mt-3 opacity-80">{item.date}</p>
        </div>
      </div>
    </Link>
  );
};

export default NewsHighlight;
